/**
 * Type Beauty — PDP / bundle / sample UI helpers (vanilla only).
 * Covers: toggle-tab "Show More", bundle shade pickers, sample color matching, Diwali selects.
 */
(function () {
  'use strict';

  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  /* ---------- Ingredients tab: show / hide full INCI list ---------- */
  function initIngredientsToggle() {
    document.addEventListener('click', function (e) {
      var btn = closest(e.target, '[data-ingredients-toggle]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      var wrapper = closest(btn, '[data-ingredients-tab]');
      if (!wrapper) return;

      var fullBlock = wrapper.querySelector('[data-ingredients-full]');
      var label = btn.querySelector('[data-ingredients-toggle-label]');
      if (!fullBlock) return;

      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      fullBlock.hidden = isOpen;
      fullBlock.classList.toggle('is-open', !isOpen);

      if (label) {
        label.textContent = isOpen ? 'Show full ingredients' : 'Hide full ingredients';
      }
    });
  }

  /* ---------- Collapsible "Show More" for toggle-tab ---------- */
  function initToggleTabs() {
    var tabs = Array.prototype.slice.call(document.querySelectorAll('toggle-tab'));
    if (tabs.length <= 6) return;
    if (document.getElementById('toggleButton')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'toggleButton';
    btn.textContent = 'Show More';
    tabs[5].after(btn);

    var extras = tabs.slice(6);
    extras.forEach(function (tab) {
      tab.hidden = true;
      tab.style.display = 'none';
    });

    btn.addEventListener('click', function () {
      var open = btn.textContent === 'Show More';
      extras.forEach(function (tab) {
        tab.hidden = !open;
        tab.style.display = open ? '' : 'none';
      });
      btn.textContent = open ? 'Show Less' : 'Show More';
    });
  }

  /* ---------- Bundle shade radio → selected text + selected-var ---------- */
  var SHADE_MAP = [
    {
      input: '.concealer-custom-shades .product-variant__input',
      scope: '.concealer-custom-shades',
      text: '.concealer-selected-shade span',
      label: '.product-variant__label'
    },
    {
      input: '.foundation-custom-shades .product-variant__input1',
      scope: '.foundation-custom-shades',
      text: '.foundation-selected-shade span',
      label: '.product-variant__label1'
    },
    {
      input: '.skin-tint-custom-shades .product-variant__input',
      scope: '.skin-tint-custom-shades',
      text: '.skin-tint-selected-shade span',
      label: '.product-variant__label'
    },
    {
      input: '.jelly-custom-shades .product-variant__input1',
      scope: '.jelly-custom-shades',
      text: '.jelly-selected-shade span',
      label: '.product-variant__label1'
    },
    {
      input: '.lip-oil-custom-shades .product-variant__input1',
      scope: '.lip-oil-custom-shades',
      text: '.lip-oil-selected-shade span',
      label: '.product-variant__label1'
    },
    {
      input: '.lip-oil-custom-shades .product-variant__input2',
      scope: '.lip-oil-custom-shades',
      text: '.lip-oil-selected-shade span',
      label: '.product-variant__label2'
    }
  ];

  function onBundleShadeClick(e) {
    var t = e.target;
    if (!t || !t.matches) return;

    for (var i = 0; i < SHADE_MAP.length; i++) {
      var cfg = SHADE_MAP[i];
      if (!t.matches(cfg.input)) continue;
      var root = closest(t, cfg.scope) || document;
      var span = root.querySelector(cfg.text) || document.querySelector(cfg.text);
      if (span) span.textContent = t.value;
      root.querySelectorAll(cfg.label).forEach(function (lab) {
        lab.classList.remove('selected-var');
      });
      var lab = t.nextElementSibling;
      while (lab && !lab.matches(cfg.label)) lab = lab.nextElementSibling;
      if (lab) lab.classList.add('selected-var');
      return;
    }
  }

  /* ---------- Sample shade match highlighting ---------- */
  function onSampleLabelClick(e) {
    var lab = closest(e.target, '.product-variant__label, .product-variant__label1, .product-variant__label3');
    if (!lab) return;
    if (!document.querySelector("input[name='product-color']")) return;

    var item = closest(lab, '.product-variant__item');
    if (item) {
      item.querySelectorAll('label').forEach(function (l) {
        l.classList.add('input-unmatched');
      });
    }

    var input = lab.previousElementSibling;
    while (input && input.tagName !== 'INPUT') input = input.previousElementSibling;
    var value = input ? input.value : '';

    document.querySelectorAll("input[name='product-color']").forEach(function (el) {
      var parent = closest(el, '.product-variant__item');
      if (!parent) return;
      var labels = parent.querySelectorAll('label');
      if (value === el.value) {
        labels.forEach(function (l) {
          l.classList.add('input-matched');
        });
      } else {
        labels.forEach(function (l) {
          l.classList.remove('input-matched', 'input-unmatched');
        });
      }
    });
  }

  /* ---------- Diwali big-select variant switching ---------- */
  function initDiwaliSelects() {
    document.querySelectorAll('.big-select').forEach(function (big) {
      var selectEl = big.querySelector('select');
      if (!selectEl) return;
      var variantDivs = big.querySelectorAll('.product__variants');
      var variantSelects = big.querySelectorAll('.side-selects');

      function showVariant() {
        var idx = selectEl.selectedIndex;
        variantDivs.forEach(function (el, i) {
          el.style.display = i === idx ? '' : 'none';
        });
        variantSelects.forEach(function (el, i) {
          el.style.display = i === idx ? '' : 'none';
        });
      }

      showVariant();
      selectEl.addEventListener('change', showVariant);
    });

    document.addEventListener('click', function (e) {
      var lab = closest(e.target, '.product-variant__label-diwali');
      if (!lab) return;
      var big = closest(lab, '.big-select');
      if (!big) return;
      big.querySelectorAll('.product-variant__label-diwali').forEach(function (el) {
        el.classList.remove('selected-var');
      });
      lab.classList.add('selected-var');
    });
  }

  /* ---------- Jelly tint: Blush ↔ Highlighter section label ---------- */
  var JELLY_HIGHLIGHTER_SHADES = {
    'pink ice': true,
    'diamond dust': true,
    'gold flakes': true
  };

  function initJellyTypeLabel() {
    var label = document.querySelector('[data-jelly-type-label]');
    if (!label) return;

    function updateLabel(value) {
      var key = (value || '').trim().toLowerCase();
      label.textContent = JELLY_HIGHLIGHTER_SHADES[key] ? 'Highlighter' : 'Blush';
    }

    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || !input.matches || !input.matches('.product-variant-value')) return;
      if (!input.checked) return;
      updateLabel(input.value);
    });

    var checked = document.querySelector('.product-variant-value:checked');
    if (checked) updateLabel(checked.value);
  }

  /* ---------- Lipstick / smudge shade category tabs ---------- */
  function initShadeCategoryTabs() {
    var groups = document.querySelectorAll('.product-variant[data-shade-tabs]');
    if (!groups.length) return;

    groups.forEach(function (group) {
      var tabsRoot = group.querySelector('[data-tb-shade-tabs]');
      var container = group.querySelector('.product-variant__container');
      if (!tabsRoot || !container) return;

      var items = Array.prototype.slice.call(
        container.querySelectorAll('.product-variant__item[data-shade-category]')
      );
      if (!items.length) return;

      function setTab(category) {
        if (!category) return;
        tabsRoot.querySelectorAll('.tb-shade-tabs__tab').forEach(function (tab) {
          var active = tab.getAttribute('data-shade-tab') === category;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        items.forEach(function (item) {
          var match = item.getAttribute('data-shade-category') === category;
          item.classList.toggle('is-shade-tab-hidden', !match);
        });
      }

      function categoryForValue(value) {
        var needle = (value || '').trim().toLowerCase();
        for (var i = 0; i < items.length; i++) {
          var input = items[i].querySelector('.product-variant__input, .product-variant-value');
          if (input && (input.value || '').trim().toLowerCase() === needle) {
            return items[i].getAttribute('data-shade-category');
          }
        }
        return null;
      }

      tabsRoot.addEventListener('click', function (e) {
        var tab = e.target.closest('.tb-shade-tabs__tab');
        if (!tab || !tabsRoot.contains(tab)) return;
        e.preventDefault();
        setTab(tab.getAttribute('data-shade-tab'));
      });

      group.addEventListener('change', function (e) {
        var input = e.target;
        if (!input || !input.matches || !input.matches('.product-variant-value, .product-variant__input')) {
          return;
        }
        if (!input.checked) return;
        var cat = categoryForValue(input.value);
        if (cat) setTab(cat);
      });

      var checked = group.querySelector('.product-variant-value:checked, .product-variant__input:checked');
      var initial =
        (checked && categoryForValue(checked.value)) ||
        (tabsRoot.querySelector('.tb-shade-tabs__tab.is-active') &&
          tabsRoot.querySelector('.tb-shade-tabs__tab.is-active').getAttribute('data-shade-tab')) ||
        (items[0] && items[0].getAttribute('data-shade-category'));
      setTab(initial);
    });
  }

  function boot() {
    initIngredientsToggle();
    initToggleTabs();
    initDiwaliSelects();
    initJellyTypeLabel();
    initShadeCategoryTabs();
    document.addEventListener('click', onBundleShadeClick);
    document.addEventListener('click', onSampleLabelClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
